import { AsyncSelectComponent as AsyncSelect } from './AsyncSelect';

export default AsyncSelect;
